import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Testimonials from "./Testimonials";
import Steps from "./Steps";
import FitSection from "./FitSection";
import Team from "./Team";
import FAQ from "./FAQ";
import FinalCTA from "./FinalCTA";
import SiteFooter from "./SiteFooter";
import useFadeIn from "../../hooks/useFadeIn";
import { TESTIMONIALS_1, TESTIMONIALS_2, STRINGS } from "../../data/content";

export default function LandingPage() {
  useFadeIn([]);

  return (
    <div className="site-root">
      <Navbar />
      <Hero />
      <Testimonials
        bg="off-white"
        label={STRINGS.athletesLabel}
        title={STRINGS.athletesTitle}
        items={TESTIMONIALS_1}
        showCta
      />
      <Steps />
      <FitSection />
      <Team />
      <Testimonials
        bg="white"
        label={STRINGS.resultsLabel}
        title={STRINGS.resultsTitle}
        items={TESTIMONIALS_2}
        showCta
      />
      <FAQ />
      <FinalCTA />
      <SiteFooter />
    </div>
  );
}
